import { EntityType } from '../../entities/enums/entity-type.enum';
import { EntityStatus } from '../enums/entity-status.enum';
import { IBusinessIdentifier } from './business-identifier.interface';
import { ILocale } from './locale.interface';
import { IWebHook } from './web-hook.interface';

export interface IEntity {
  entityUid?: string;
  altVfiEntityId?: string;
  name?: string;
  friendlyName?: string;
  legalName?: string;
  description?: string;
  email?: string;
  locale?: ILocale;
  industry?: string;
  url?: string;
  taxRegistrationNumber?: string;
  businessIdentifiers?: IBusinessIdentifier[];
  labels?: string[];
  tokenEntityId?: string;
  webHooks?: IWebHook[];
  status?: EntityStatus;
  parentEntityUid?: string;
  createdDate?: string;
  modifiedDate?: string;
  version?: number;
  entityType?: EntityType;
  objectType?: string;
  merchantLogoUrl?: string;
  verifoneBillingCurrency?: string;
  hasChildren?: boolean;
  count?: number;
  domainName?: string;
  loginDomainName?: string;
  emailDomainName?: string;
  children?: IEntity[];
}

export interface IUserQueryWithEntity {
  entityUid: string[];
  name?: string;
}
